import React, { Component } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import PropTypes from 'prop-types';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { CSVLink } from 'react-csv';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Search from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  MuiPickersUtilsProvider,
  InlineDatePicker
} from 'material-ui-pickers';

import { FaFileExport } from 'react-icons/fa';

import { getAllConsumerActions } from './queries';
import { Dialog } from '../../../../components';
import ActionDetailDialog from './ActionDetail';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import styles from './styles';
import { colors } from '../../../../constants';

// assets
import ExpandLessOutlined from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlined from '@material-ui/icons/ExpandMoreOutlined';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const ArrowUp = withStyles(() => ({
  root: {
    marginBottom: -7
  }
}))(ExpandLessOutlined);

const ArrowDown = withStyles(() => ({
  root: {
    marginBottom: -7
  }
}))(ExpandMoreOutlined);

class TableAction extends Component {
  state = {
    open: false,
    title: '',
    content: '',
    search: '',
    type: '',
    action: '',
    searchmerchant: '',
    page: 1,
    limit: 15,
    sortBy: 'createdDate',
    sortOrder: 'desc',
    fromDate: null,
    toDate: null,
    isActionDetailBoxShown: false,
    dealId: null,
    exportData: [],
    exporting: false,
  };

  onOk = () => {
    this.setState({ open: false });
  }

  onSearch = (event) => {
    this.setState({ search: event.target.value, page: 1 });
  }

  onSortByName = () => {
    const { sortBy, sortOrder } = this.state;
    const nextOrder = sortBy === 'username' && sortOrder === 'asc' ? 'desc' : 'asc';
    this.setState({
      sortBy: 'username',
      sortOrder: nextOrder,
      page: 1,
    });
  }

  onSortByDate = () => {
    const { sortBy, sortOrder } = this.state;
    const nextOrder = sortBy === 'createdDate' && sortOrder === 'desc' ? 'asc' : 'desc';
    this.setState({
      sortBy: 'createdDate',
      sortOrder: nextOrder,
      page: 1,
    });
  }

  onExportFile = () => {
    const { client } = this.props;
    if (!client) return;

    this.setState({ exporting: true }, async () => {
      try {
        const baseInput = {
          ...this.buildFiltersInput(),
          page: 1,
          limit: this.state.limit || 15,
        };

        const firstResult = await client.query({
          query: getAllConsumerActions,
          variables: { input: baseInput },
          fetchPolicy: 'no-cache',
        });
        const firstPayload = firstResult && firstResult.data
          ? firstResult.data.getAllConsumerActions
          : null;

        if (!firstPayload || !firstPayload.count_rows) {
          this.setState({ exporting: false, exportData: [] });
          return;
        }

        let allActions = (firstPayload.actions || []).slice();
        const totalPage = firstPayload.total_page || 1;

        for (let currentPage = 2; currentPage <= totalPage; currentPage += 1) {
          const pageResult = await client.query({
            query: getAllConsumerActions,
            variables: {
              input: {
                ...baseInput,
                page: currentPage,
              },
            },
            fetchPolicy: 'no-cache',
          });
          const pagePayload = pageResult && pageResult.data
            ? pageResult.data.getAllConsumerActions
            : null;
          if (pagePayload && pagePayload.actions && pagePayload.actions.length) {
            allActions = allActions.concat(pagePayload.actions);
          }
        }

        const exportData = allActions.map(obj => ({
          ...obj,
          consumer: obj.consumer ? obj.consumer.username : '',
          merchant: obj.merchant ? obj.merchant.username : '',
        }));

        this.setState({ exportData, exporting: false }, () => {
          if (this.csvLinkRef) {
            this.csvLinkRef.link.click();
          }
        });
      } catch (error) {
        this.setState({ exporting: false });
      }
    });
  }

  onFilterType = (e) => {
    this.setState({ type: e.target.value, page: 1 });
  }

  onFilterAction = (e) => {
    this.setState({ action: e.target.value, page: 1 });
  }

  onFilterMerchant = (e) => {
    this.setState({ searchmerchant: e.target.value, page: 1 });
  }

  resetFilterByDate = () => {
    this.setState({
      fromDate: null,
      toDate: null,
      page: 1,
    });
  }

  closeActionDetailBox = () => {
    this.setState({ isActionDetailBoxShown: false });
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page + 1 });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value, page: 1 });
  }

  handleOpenDetailAction = (dealId) => {
    this.setState({ isActionDetailBoxShown: true, dealId });
  }

  buildFiltersInput = () => {
    const {
      fromDate, toDate, search, type, action, searchmerchant, sortBy, sortOrder,
    } = this.state;
    return {
      fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
      toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
      search: search || null,
      type: type || null,
      action: action || null,
      merchantUsername: searchmerchant || null,
      sortBy: sortBy || 'createdDate',
      sortOrder: sortOrder || 'desc',
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      page, limit, fromDate, toDate, search, type, action, searchmerchant, sortBy, sortOrder,
    } = this.state;
    if (
      prevState.page !== page
      || prevState.limit !== limit
      || prevState.fromDate !== fromDate
      || prevState.toDate !== toDate
      || prevState.search !== search
      || prevState.type !== type
      || prevState.action !== action
      || prevState.searchmerchant !== searchmerchant
      || prevState.sortBy !== sortBy
      || prevState.sortOrder !== sortOrder
    ) {
      this.refetchData();
    }
  }

  refetchData = () => {
    const { refetch } = this.props;
    if (refetch) {
      const { page, limit } = this.state;
      refetch({
        input: {
          ...this.buildFiltersInput(),
          page: page || 1,
          limit: limit || 15,
        },
      });
    }
  }

  renderExportButtonLabel = () => {
    const { classes } = this.props;
    const { exporting } = this.state;
    return (
      <Typography component="p" className={classes.text}>
        {exporting ? 'Exporting...' : 'Export'}
      </Typography>
    );
  }

  render() {
    const { classes, getAllConsumerActions: actionsData } = this.props;
    const actions = (actionsData && actionsData.actions) || [];
    const pagination = actionsData || {};
    const {
      title, content, open, search, type, action, searchmerchant, page, limit,
      fromDate, toDate, exportData, exporting, sortBy, sortOrder,
    } = this.state;

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <Dialog
            title={title}
            content={content}
            open={open}
            onOk={() => this.onOk()}
          />
          {
            this.state.dealId
            && (
              <ActionDetailDialog
                title="Action Dialog"
                dealId={this.state.dealId}
                open={this.state.isActionDetailBoxShown}
                onOk={() => this.closeActionDetailBox()}
              />
            )
          }
          <div className={classes.searchWrapper}>
            <Typography variant="body1" className={classes.filterLabel}>Name Filter</Typography>
            <CustomInput
              formControlProps={{
                className: `${classes.margin} ${classes.search}`,
                style: { margin: 0 }
              }}
              inputProps={{
                value: search,
                onChange: this.onSearch,
                placeholder: 'Search',
                inputProps: {
                  'aria-label': 'Search',
                },
              }}
            />
            <Button aria-label="edit" disabled>
              <Search />
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.onExportFile}
              disabled={exporting}
            >
              {this.renderExportButtonLabel()}
              <FaFileExport color="#ffffff" size={16} />
            </Button>
            <CSVLink
              style={{ display: 'none' }}
              data={exportData}
              filename={`consumer-action-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
              ref={(r) => { this.csvLinkRef = r; }}
            >
              Export
            </CSVLink>
            <Typography component="p" style={{ fontSize: '14px', alignSelf: 'center' }}>
              Rows: {pagination.count_rows || 0}
            </Typography>
          </div>
          <div>
            <Typography variant="body1" className={classes.filterLabel}>Date Filter</Typography>
            <Grid key="date-filter" container>
              <Grid key="from" container item xs={12} md={8}>
                <Grid item xs={12} sm={6}>
                  <InlineDatePicker
                    label="From"
                    id="date-from"
                    onChange={(date) => this.setState({ fromDate: date, page: 1 })}
                    format="yyyy-MM-dd"
                    value={fromDate}
                  />
                </Grid>
                <Grid key="to" item xs={12} sm={6}>
                  <InlineDatePicker
                    label="To"
                    id="date-to"
                    onChange={(date) => this.setState({ toDate: date, page: 1 })}
                    format="yyyy-MM-dd"
                    value={toDate}
                  />
                </Grid>
              </Grid>
              <Grid key="reset-date-filter" container item xs={12} md={4}>
                <Button variant="contained" color="primary" className={classes.button} onClick={this.resetFilterByDate}>
                  Reset
                </Button>
              </Grid>
            </Grid>
          </div>
          <div>
            <Typography variant="body1" className={classes.filterLabel}>Action {'&'} Type Filter</Typography>
            <Grid key="type-filter" container alignItems="flex-end">
              <Grid item xs={12} md={4}>
                <CustomInput
                  formControlProps={{
                    className: `${classes.margin} ${classes.search}`,
                    style: { margin: 0 }
                  }}
                  inputProps={{
                    value: type,
                    onChange: this.onFilterType,
                    placeholder: 'Type',
                    inputProps: {
                      'aria-label': 'Type',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomInput
                  formControlProps={{
                    className: `${classes.margin} ${classes.search}`,
                    style: { margin: 0 }
                  }}
                  inputProps={{
                    value: action,
                    onChange: this.onFilterAction,
                    placeholder: 'Action',
                    inputProps: {
                      'aria-label': 'Action',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomInput
                  formControlProps={{
                    className: `${classes.margin} ${classes.search}`,
                    style: { margin: 0 }
                  }}
                  inputProps={{
                    value: searchmerchant,
                    onChange: this.onFilterMerchant,
                    placeholder: 'Merchant',
                    inputProps: {
                      'aria-label': 'Merchant',
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <Paper className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <CustomTableCell style={{ cursor: 'pointer' }} onClick={this.onSortByName}>
                    Username
                    {sortBy === 'username'
                      ? (sortOrder === 'asc' ? <ArrowUp /> : <ArrowDown />)
                      : null}
                  </CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Type</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Merchant name</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Action</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow}>Detail</CustomTableCell>
                  <CustomTableCell align="right" className={classes.columnRow} style={{ cursor: 'pointer' }} onClick={this.onSortByDate}>
                    Created Date
                    {sortBy === 'createdDate'
                      ? (sortOrder === 'asc' ? <ArrowUp /> : <ArrowDown />)
                      : null}
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actions.map(row => (
                  <TableRow className={classes.row} key={row.id}>
                    <CustomTableCell component="th" scope="row">
                      {row.consumer ? row.consumer.username : ''}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>{row.objectType}</CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>{row.merchant ? row.merchant.username : ''}</CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>{row.action}</CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ margin: 0 }}
                        className={classes.button}
                        onClick={() => this.handleOpenDetailAction(row.objectId)}
                      >
                        Detail
                      </Button>
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>{row.createdDate}</CustomTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[15, 25, 50]}
              component="div"
              count={pagination.count_rows || 0}
              rowsPerPage={limit}
              page={page - 1}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

TableAction.defaultProps = {
  classes: {},
  getAllConsumerActions: {},
};

TableAction.propTypes = {
  classes: PropTypes.object,
  getAllConsumerActions: PropTypes.object,
  refetch: PropTypes.func,
  client: PropTypes.object,
};

const ListAll = graphql(getAllConsumerActions, {
  options: () => ({
    variables: {
      input: {
        page: 1,
        limit: 15,
        fromDate: null,
        toDate: null,
        search: null,
        type: null,
        action: null,
        merchantUsername: null,
        sortBy: 'createdDate',
        sortOrder: 'desc',
      },
    },
    fetchPolicy: 'network-only',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    getAllConsumerActions: data.getAllConsumerActions,
    refetch: data.refetch,
  }),
});

export default withStyles(styles)(compose(ListAll, withApollo)(TableAction));
